import React from 'react';

export const LoadingContent = () => {
  return (
    <div className="loaders-container">
      <div className="circle"></div>
    </div>
  );
};
